<script setup lang="ts">
import type { SbInvestStepsStoryblok } from '~/types/storyblok'

const { blok } = defineProps<{ blok: SbInvestStepsStoryblok }>()

const steps = computed(() => blok.steps)
</script>

<template>
  <div class="mx-[-20px] flex h-full md:mx-0">
    <div class="hide-scrollbar flex snap-x snap-mandatory scroll-pl-5 grid-cols-12 gap-5 overflow-x-auto pt-6 md:grid md:snap-none md:gap-8">
      <div class="shrink-0 snap-start md:hidden">
        <div class="w-1 shrink-0" />
      </div>

      <SBInvestStep
        v-for="(step, index) in steps"
        :key="index"
        :blok="step"
        :index
      />

      <div class="shrink-0 snap-start md:hidden">
        <div class="w-6 shrink-0" />
      </div>
    </div>
  </div>
</template>
